<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="component-container scroll-container">
  <div class="title">
    <div class="cssLayoutRowStartCenter"></div>
    <div class="cssLayoutRowStartCenter table-wrapper">
      @if (loading && !apiResponded) {
      <mat-card appearance="outlined" style="
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
        ">
        <mat-progress-spinner color="primary" mode="indeterminate">
        </mat-progress-spinner>
      </mat-card>
      }

      <div class="table-container">
      <table mat-table [dataSource]="modelDataSource" matSort class="elevate" [hidden]="modelDataSource.data.length < 1"
        multiTemplateDataRows>
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button title="Copy Task" (click)="copyTask(element.id); $event.stopPropagation()">
              <mat-icon fontIcon="mdi-content-copy"></mat-icon>
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="statusDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
          <td mat-cell *matCellDef="let element" class="date-column">
            {{ element.statusDate | date: 'yyyy-MM-dd HH:mm:ss' }}
          </td>
        </ng-container>
        <ng-container matColumnDef="vmName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>VM Name</th>
          <td mat-cell *matCellDef="let element">
            {{ element.vmName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let element" class="status-column">
            <mat-icon [fontIcon]="statusIcon(element.status)" class="icon-20" title="{{ element.status }}"></mat-icon>
            {{ element.status | titlecase }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actualOutput">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Actual</th>
          <td mat-cell *matCellDef="let element">
            <span title="{{ element.actualOutput }}">
              {{ element.actualOutput }}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="expectedOutput">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Expected</th>
          <td mat-cell *matCellDef="let element">
            <span title="{{ element.expectedOutput }}">
              {{ element.expectedOutput }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let result" [attr.colspan]="displayedColumns.length">
            <div [@detailExpand]="
                result === expandedResult ? 'expanded' : 'collapsed'
              " (click)="$event.stopPropagation()">
              <div class="result-details">
                id: {{ result.id }}<br />
                vmId: {{ result.vmId }}<br />
                vmName: {{ result.vmName }}<br />
                apiUrl: {{ result.apiUrl }}<br />
                action: {{ result.action }}<br />
                actionParameters:<br />
                @for (k of result.actionParameters | keyvalue; track k) {
                <span>&nbsp;&nbsp;&nbsp;&nbsp;{{ k.key }}:
                  {{
                  k.key.toLowerCase() === 'password'
                  ? '**************'
                  : k.value
                  }}<br /></span>
                }
                expirationSeconds: {{ result.expirationSeconds }}<br />
                iteration {{ result.currentIteration }} of {{ result.iterations
                }}<br />
                intervalSeconds: {{ result.intervalSeconds }}<br />
                status: {{ result.status }}<br />
                expectedOutput: {{ result.expectedOutput }}<br />
                actualOutput: {{ result.actualOutput }}<br />
                dateCreated:
                {{ result.dateCreated | date: 'yyyy/MM/dd HH:mm:ss' }}<br />
                statusDate: {{ result.statusDate | date: 'yyyy/MM/dd HH:mm:ss'
                }}<br />
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="element-row" (click)="showDetail(row)"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row" (click)="showDetail(row)"></tr>
      </table>
      </div>
    </div>
    <div class="cssLayoutRowStartCenter"></div>
  </div>

</div>
